import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMusicbrainzComponent } from './simple-icons-musicbrainz.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMusicbrainzComponent ],
    exports:      [ SimpleIconsMusicbrainzComponent ],
    bootstrap:    []
})
export class SimpleIconsMusicbrainzModule {}
